import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Modal,
  Carousel,
  Spinner,
} from "react-bootstrap";
import Cookies from "js-cookie";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  faEye,
  faEyeSlash,
  faLock,
  faUser,
  faInfo,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import useReactRouter from "use-react-router";
import { errorSwal } from "../../helpers/sweetalert";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import Lottie from "react-lottie";
import { useMutation, useLazyQuery } from "@apollo/client";
import { isMobile, isDesktop } from 'react-device-detect';
// style
import "./login.css";
import { USER_LOGIN } from "../../graphql/login/login";
import { SHOP } from "../../graphql/shop/queryShop";
import { GET_POPUPS } from "../../graphql/popup/query";
import { faFacebook, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "@lottiefiles/lottie-player";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { checkExpiredShop } from "../../helpers";
import logoLogin from "../../image/logo_main.png";
import {
  ACCESS_TOKEN,
  BG_GRADIENT_NEW,
  COLOR_APP,
  COLOR_TEXT,
  COLOR_WHITE,
  CONTACT_4B_TEAM,
  K_LOCAL_STORAGE_SHOP_SETTING_DATA,
  WEB_LANDING_PAGE_URL, 
} from "../../constants";
import { GET_SETTING_BY_SHOP } from "../../graphql/setting/query";

const emptySystem =
  "https://media.istockphoto.com/id/1386740242/vector/vector-bubbles-with-question-mark-question-icons-isolated-on-white.jpg?s=612x612&w=0&k=20&c=evjrckVKb_RVRcN5qV1Tz1pkSu3FvHKCGtynu8btxhA=";


const bannerDatas = [
  {
    image: "/images/banner-login/logistics-fcn.jpg"
  },
  {
    image: "/images/banner-login/payment-fcn.jpg"
  },
  {
    image: "/images/banner-login/term_24.jpg"
  },
]


function Login() {
  const { history } = useReactRouter();
  const { height, width } = useWindowDimensions();
  const [popupDate, setPopupData] = useState(null);
  const [checkUser, setCheckUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSystem, setIsSystem] = useState(false);
  const [isPasswordType, setIsPasswordType] = useState(true);
  const [userLogin] = useMutation(USER_LOGIN);
  const [getShop, { data: shopData }] = useLazyQuery(SHOP);
  const [getSettingByShop] = useLazyQuery(GET_SETTING_BY_SHOP, { fetchPolicy: "cache-and-network" });
  const [getPopup, { data: popupData }] = useLazyQuery(GET_POPUPS, {
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    getPopup({
      variables: {
        where: {
          position: "login",
          isPublished: true,
        },
        orderBy: "updatedAt_DESC",
      },
    });
  }, []);

  useEffect(() => {
    if (popupData?.popups?.data.length > 0)
      setPopupData(popupData?.popups?.data[0]);
    if (shopData?.shop) {
      checkExpiredShop(shopData?.shop);
      // happyBirthDay(shopData?.shop)
    }
  }, [shopData, popupData]);

  // Check device
  const deviceType = isMobile ? 'Mobile' : isDesktop ? 'Desktop' : 'Unknown';

  const _login = async ({ values }) => {
    try {
      setIsLoading(true);
      if (values.userId && values.password) {
        // Clear local storage
        localStorage.clear();
        const _userLogin = await userLogin({
          variables: {
            where: {
              username: values.userId,
              password: values.password,
            },
          },
        });
        if (_userLogin?.data?.loginUser) {
          const _userData = _userLogin?.data?.loginUser;
          if (_userData?.data?.shop) {
            await getShop({
              variables: {
                where: {
                  id: _userData?.data?.shop?.id,
                },
              },
            });
          }
          // Set a cookie
          Cookies.set(ACCESS_TOKEN, _userLogin?.data?.loginUser?.accessToken, {
            expires: 1,
          }); // Expires in 1 day

          await localStorage.setItem(
            "USER_DATA",
            JSON.stringify(_userLogin?.data?.loginUser)
          );
          await localStorage.setItem("SHOP", _userData?.data?.shop?.id);
          await localStorage.setItem("TEXT_TO_SPEECH", isMobile === 'Mobile' ? true : false);
          await localStorage.setItem("DEVICE_TYPE", deviceType);

          // Get Setting
          const settingByShop = await getSettingByShop({
            variables: {
              where: {
                shop: _userData?.data?.shop?.id,
              },
            },
          });

          if (settingByShop?.data?.settingByShopId) {
            localStorage.setItem(K_LOCAL_STORAGE_SHOP_SETTING_DATA, JSON.stringify(settingByShop?.data?.settingByShopId));
          }

          history.push("/dashboard");
          // history.push("/total-summary");
          setIsLoading(false);
        }
      }
    } catch (err) {
      setIsLoading(false);
      setIsSystem(false);

      if (err.message === "CAN_THIS_ACCOUNT_USE_THE_4B_LIVE") {
        setIsSystem(true);
        return;
      }

      errorSwal("ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານຂອງທ່ານບໍ່ຖືກຕ້ອງ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ");
    }
  };

  return (
    <>
      {width > 700 ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              background: "#ffffff",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Formik
              initialValues={{ userId: "", password: "" }}
              validationSchema={Yup.object({
                userId: Yup.string().required("ກາລຸນາປ້ອນຊື່ຜູ້ໃຊ້"),
                password: Yup.string().required("ກາລຸນາປ້ອນລະຫັດຜ່ານ"),
              })}
              validate={(values) => {
                const errors = {};
                if (!values.userId) {
                  errors.userId = "ກາລຸນາປ້ອນຊື່ຜູ້ໃຊ້!";
                }
                if (!values.password) {
                  errors.password = "ກາລຸນາປ້ອນລະຫັດຜ່ານ!";
                }
                return errors;
              }}
              onSubmit={async (values) => {
                await _login({ values });
              }}
            >
              {({
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
                errors,
                values,
              }) => (
                <Form className="" style={{ width: "50%" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        paddingBottom: 45,
                        display: "flex",
                      }}
                    ></div>
                    <img
                      src={logoLogin}
                      alt="profileLogin"
                      style={{ width: "auto", height: "10vh", border: '1px solid #f3f3f3 ', borderRadius: 10 }}
                    />
                    <h1 style={{ fontSize: 28, fontWeigth: 'bold' }}>
                      Super CF
                    </h1>
                    <p style={{ fontSize: 15 }}>ປ້ອນຂໍ້ມູນເພື່ອເຂົ້າສູ່ລະບົບ</p>
                    <div
                      className="text-start"
                      style={{
                        width: "100%",
                        color: "#4B4A4A",
                        fontSize: 17,
                        fontWeight: "bold",
                      }}
                    >
                      ຊື່ຜູ້ໃຊ້ລະບົບ
                    </div>
                    <div style={{ height: 5 }} />
                    <Form.Control
                      type="text"
                      placeholder="ຊື່ຜູ້ໃຊ້..."
                      onChange={handleChange("userId")}
                      onBlur={handleBlur}
                      value={values.userId}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                    {errors.userId && (
                      <div className="text-start" style={{ width: "100%" }}>
                        <span style={{ fontSize: 12, color: "#F03649" }}>
                          {errors.userId}
                        </span>
                      </div>
                    )}
                    <div style={{ height: 12 }} />
                    <div
                      className="text-start"
                      style={{
                        width: "100%",
                        color: "#4B4A4A",
                        fontSize: 17,
                        fontWeight: "bold",
                      }}
                    >
                      ລະຫັດຜ່ານ
                    </div>
                    <div
                      style={{
                        border: "1px solid #ced4da",
                        width: "100%",
                        borderRadius: 4,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ height: 5 }} />
                      <Form.Control
                        type={isPasswordType ? "password" : "text"}
                        placeholder="ລະຫັດຜ່ານ..."
                        onChange={handleChange("password")}
                        onBlur={handleBlur}
                        value={values.password}
                        style={{ borderWidth: 0 }}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            handleSubmit();
                          }
                        }}
                      />
                      <FontAwesomeIcon
                        onClick={() => setIsPasswordType(!isPasswordType)}
                        style={{ float: "right", marginRight: 8 }}
                        icon={isPasswordType ? faEye : faEyeSlash}
                      />
                    </div>
                    <div style={{ width: "100%", display: "flex" }}>
                      {errors.password && (
                        <div className="text-start" style={{ width: "100%" }}>
                          <span style={{ fontSize: 12, color: "#F03649" }}>
                            {errors.password}
                          </span>
                        </div>
                      )}
                      {/* <div className="text-end" style={{ width: "100%", color: "#4B4A4A", cursor: "pointer" }}><u>ລືມລະຫັດຜ່ານ ?</u></div> */}
                    </div>
                    <div style={{ height: 35 }} />
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "red",
                        display: checkUser === false ? "none" : "",
                      }}
                    >
                      ຊື່ຜູ້ໃຊ້ລະບົບ ຫຼື ຊື່ຜູ້ໃຊ້ລະບົບ ບໍ່ຖືກຕ້ອງ
                    </div>
                    <Button
                      style={{
                        background: COLOR_APP,
                        border: "none",
                        boxShadow: "0 1px 1px rgba(75, 2, 131, 1)",
                        marginLeft: 0,
                        width: "100%",
                        fontSize: 18,
                        padding: "11px",
                        display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 5
                      }}
                      onClick={handleSubmit}
                    >
                      <FontAwesomeIcon
                        icon={faSignOutAlt}
                        style={{ color: "#fffff", fontSize: 21, width: 33 }}
                      />
                      ເຂົ້າສູ່ລະບົບ{" "}
                    </Button>
                    <div style={{ height: 30 }} />
                    {/* <a href="https://dntgg8eiiw3ps.cloudfront.net/" target="_blank" style={{ cursor: "pointer", color: 'blue' }}><u>Old version</u></a> */}
                    {/* <div style={{ height: 30 }} /> */}
                    <p>
                      ນະໂຍບາຍການນໍາໃຊ້ລະບົບຂອງພວກ{" "}
                      <a
                        style={{ fontSize: "FontLao", color: "#707B7C" }}
                        href="/privacy-policy"
                        target="_blank"
                      >
                        {" "}
                        <u
                          style={{
                            cursor: "pointer",
                            color: "#422f90",
                            fontWeight: "bold",
                          }}
                        >
                          ກົດນີ້ເພື່ອອ່ານ
                        </u>
                      </a>{" "}
                    </p>
                    <div style={{ height: 1 }} />
                    <div
                      style={{
                        padding: 9,
                        background: "#fff",
                      }}
                    ></div>
                    <div className="h-divider">
                      <div className="shadow"></div>
                    </div>
                    <br />
                    <div
                      style={{
                        cursor: "pointer",
                        margin: "center",
                        fontWeight: "bold",
                        color: COLOR_APP,
                        marginTop: "-.5em",
                      }}
                      onClick={() => {
                        window.open(WEB_LANDING_PAGE_URL + "/#pricing");
                      }}
                    >
                      <u>ລາຄາແພັກເກັດ</u>
                    </div>
                    <div style={{ height: 20 }} />
                    <div style={{ margin: "center", fontWeight: "bold" }}>
                      <p>ສົນໃຈລະບົບ ຫຼື ຢາກສອບຖາມຂໍ້ມູນເພີ່ມຕື່ມໄດ້ທີ່</p>
                    </div>

                    <div>
                      <a
                        href="https://www.facebook.com/LailaoCF"
                        target="_blank"
                        style={{ textDecoration: "none" }}
                      >
                        {" "}
                        <FontAwesomeIcon
                          icon="fa-brands fa-whatsapp"
                          style={{
                            cursor: "pointer",
                            color: "#4267B2",
                            fontSize: 35,
                            margin: "center",
                            marginLeft: 5,
                            marginRight: 15,
                          }}
                        />
                      </a>
                      <a
                        href="https://www.facebook.com/LailaoCF"
                        target="_blank"
                        style={{ textDecoration: "none" }}
                      >
                        {" "}
                        <FontAwesomeIcon
                          icon={faFacebook}
                          style={{
                            cursor: "pointer",
                            color: "#4267B2",
                            fontSize: 35,
                            margin: "center",
                            marginLeft: 5,
                            marginRight: 15,
                          }}
                        />
                      </a>
                      <a
                        href="https://wa.link/094p9u"
                        target="_blank"
                        style={{ textDecoration: "none" }}
                      >
                        {" "}
                        <FontAwesomeIcon
                          icon={faWhatsapp}
                          style={{
                            cursor: "pointer",
                            color: "#25d366",
                            fontSize: 40,
                            margin: "center",
                            marginLeftt: 50,
                          }}
                        />
                      </a>
                    </div>


                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div
            style={{
              padding: 5,
              width: "100%",
              background: BG_GRADIENT_NEW,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              height: "100vh",
            }}
          >

            <Carousel
              interval={1500}
              style={{ width: "100%", height: "100%" }}
              prevIcon={false}
              nextIcon={false}
            >
              {bannerDatas.map((item, index) => (
                <Carousel.Item key={index} style={{ height: '40em', overflow: 'hidden' }}>
                  <img
                    src={item?.image}
                    alt="Third slide"
                    style={{ width: "100%", height: '100%', objectFit: 'contain' }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </div>
      ) : (
        <div
          style={{
            background: COLOR_APP,
            width: width,
            height: '100vh',
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Formik
            initialValues={{ userId: "", password: "" }}
            validate={(values) => {
              const errors = {};
              if (!values.userId) {
                errors.userId = "ກາລຸນາປ້ອນຊື່ຜູ້ໃຊ້!";
              }
              if (!values.password) {
                errors.password = "ກາລຸນາປ້ອນລະຫັດຜ່ານ!";
              }
              return errors;
            }}
            onSubmit={async (values) => {
              await _login({ values });
            }}
          >
            {({
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
              errors,
              values,
            }) => (
              <Form className="" style={{ marginTop: 0 }}>
                <div className="d-flex w-100 justify-content-center flex-column align-items-center">
                  <div
                    style={{
                      background: COLOR_WHITE,
                      width: 130,
                      height: 130,
                      padding: 8,
                      borderRadius: 25,
                      overflow: "hidden",
                      boxXhadow: 'rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px'
                    }}
                  >
                    <img
                      src={logoLogin}
                      alt="profileLogin"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>

                  <h1
                    style={{
                      color: COLOR_WHITE,
                      fontSize: "2em",
                      paddingTop: ".5em",
                      fontWeight: "bold",
                    }}
                  >
                    ລະບົບ Super CF
                  </h1>
                </div>
                {/* Text Field And Button Login */}
                <div style={{ marginLeft: 53, marginRight: 53 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ height: 45 }} />
                    <div
                      className="text-start"
                      style={{
                        width: "100%",
                        color: COLOR_WHITE,
                        fontSize: 20,
                        display: "flex",
                      }}
                    >
                      ຊື່ນຳໃຊ້ລະບົບ
                      <p
                        style={{
                          color: "red",
                          margin: 0,
                          paddingTop: 3,
                          paddingLeft: 5,
                        }}
                      >
                        *
                      </p>
                    </div>
                    <div
                      style={{
                        border: "1px solid #ced4da",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        background: "white",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faUser}
                        style={{ float: "right", marginLeft: 8 }}
                      />
                      <Form.Control
                        style={{ borderWidth: 0 }}
                        type="text"
                        placeholder="ຊື່ຜູ້ໃຊ້..."
                        onChange={handleChange("userId")}
                        onBlur={handleBlur}
                        value={values.userId}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            handleSubmit();
                          }
                        }}
                      />
                      <FontAwesomeIcon
                        icon={faInfo}
                        style={{ float: "right", marginRight: 8 }}
                      />
                    </div>
                    {errors.userId && (
                      <div className="text-start" style={{ width: "100%" }}>
                        <span style={{ fontSize: 12, color: "red" }}>
                          {errors.userId}
                        </span>
                      </div>
                    )}

                    <div style={{ height: 10 }} />
                    <div
                      className="text-start"
                      style={{
                        width: "100%",
                        color: COLOR_WHITE,
                        fontSize: 20,
                        display: "flex",
                      }}
                    >
                      ລະຫັດຜ່ານ
                      <p
                        style={{
                          color: "red",
                          margin: 0,
                          paddingTop: 3,
                          paddingLeft: 5,
                        }}
                      >
                        *
                      </p>
                    </div>
                    <div
                      style={{
                        border: "1px solid #ced4da",
                        width: "100%",
                        borderRadius: 4,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        background: "white",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faLock}
                        style={{ float: "right", marginLeft: 8 }}
                      />
                      <Form.Control
                        type={isPasswordType ? "password" : "text"}
                        placeholder="ລະຫັດຜ່ານ..."
                        onChange={handleChange("password")}
                        onBlur={handleBlur}
                        value={values.password}
                        style={{ borderWidth: 0 }}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            handleSubmit();
                          }
                        }}
                      />
                      <FontAwesomeIcon
                        onClick={() => setIsPasswordType(!isPasswordType)}
                        style={{ float: "right", marginRight: 8 }}
                        icon={isPasswordType ? faEye : faEyeSlash}
                      />
                    </div>
                    <div style={{ width: "100%", display: "flex" }}>
                      {errors.password && (
                        <div className="text-start" style={{ width: "100%" }}>
                          <span style={{ fontSize: 12, color: "red" }}>
                            {errors.password}
                          </span>
                        </div>
                      )}
                      <div
                        className="text-end"
                        style={{
                          width: "100%",
                          color: "#4B4A4A",
                          cursor: "pointer",
                          marginTop: 10,
                        }}
                      >
                        {/* <u>ລືມລະຫັດຜ່ານ ?</u> */}
                      </div>
                    </div>
                    {/* <p style={{textAlign: 'end'}}> ລືມລະຫັດຜ່ານ ?</p> */}
                    <div style={{ height: 15 }} />
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "red",
                        display: checkUser === false ? "none" : "",
                      }}
                    >
                      ຊື່ຜູ້ໃຊ້ລະບົບ ຫຼື ຊື່ຜູ້ໃຊ້ລະບົບ ບໍ່ຖືກຕ້ອງ
                    </div>
                    <Button
                      style={{
                        background: "white",
                        border: `1px solid #fff`,
                        marginLeft: 0,
                        width: "100%",
                        color: COLOR_TEXT,
                        fontSize: 18,
                      }}
                      onClick={handleSubmit}
                    >
                      ເຂົ້າສູ່ລະບົບ{" "}
                    </Button>
                    <div style={{ height: 50 }} />
                    <div
                      style={{
                        cursor: "pointer",
                        margin: "center",
                        fontWeight: "bold",
                        color: COLOR_WHITE,
                        marginTop: "-.5em",
                      }}
                      onClick={() => {
                        window.open(WEB_LANDING_PAGE_URL + "/#pricing");
                      }}
                    >
                      <u>ລາຄາແພັກເກັດ</u>
                    </div>
                    <div style={{ height: 10 }} />
                    <a
                      onClick={() => history.push("/privacy-policy")}
                      style={{ cursor: "pointer", color: COLOR_WHITE }}
                    >
                      <u>ນະໂຍບາຍຄວາມປອດໄປ</u>
                    </a>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}

      {/* Config Modal */}
      {popupDate && (
        <Modal
          show={popupDate?.isPublished}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            {width > 700 ? (
              <h3>{popupDate?.title ?? ""}</h3>
            ) : (
              <h5>{popupDate?.title ?? ""}</h5>
            )}
          </Modal.Header>
          <Modal.Body
            style={{
              padding: 24,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            {width > 700 ? (
              <h5 style={{ textAlign: "center" }}>{popupDate?.detail ?? ""}</h5>
            ) : (
              <h6 style={{ textAlign: "center" }}>{popupDate?.detail ?? ""}</h6>
            )}
            <br />
            {popupDate?.animation && (
              <Lottie
                options={{
                  loop: true,
                  path: popupDate?.animation,
                }}
                width={width > 700 ? 400 : width * 0.8}
              />
            )}
          </Modal.Body>
        </Modal>
      )}

      <Modal show={isLoading} keyboard={false} centered>
        <div
          style={{
            padding: 30,
            height: "20em",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner style={{ color: COLOR_TEXT }} />
          <p style={{ fontSize: 25, paddingTop: 5 }}>ກໍາລັງເຂົ້າສູ່ລະບົບ...</p> 
        </div>
      </Modal>

      <Modal show={isSystem} centered>
        <div
          style={{
            padding: 30,
            height: "20em",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={emptySystem} style={{ width: 130, height: 100 }} />
          <h3>ບັນຊີນີ້ບໍມີສິດເຂົ້າເຖິງລະບົບດູດ!!</h3>
          <p style={{ color: "orange", textAlign: "center" }}>
            ຕ້ອງການສອບຖາມຂໍ້ມູນເພິ່ມເຕີມ ໃຫ້ກົດປຸ່ມ ສອບຖາມຂໍ້ມູນ
            ເພື່ອຕິດຕໍ່ຫາທີມງານ ດູແລລະບົບ 4B-(ໂຟບີ) ໄລຟ
          </p>
        </div>
        <div className="card-footer-modals">
          <div className="btn-cancel-modals" onClick={() => setIsSystem(false)}>
            ຍົກເລີກ
          </div>
          <div
            className="btn-contact-team"
            onClick={() => {
              window.open(CONTACT_4B_TEAM);
            }}
          >
            ສອບຖາມຂໍ້ມູນ
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Login;
